import { CompassContextType } from '@/src/libs/CompassContext';

export const DEFAULT_CENTER = {
  lat: 42.3974392,
  lng: -83.0656352,
};

export const initializeMap = (
  ctx: CompassContextType,
  ref: React.RefObject<HTMLDivElement>
) => {
  const center = new google.maps.LatLng(
    DEFAULT_CENTER as google.maps.LatLngLiteral
  );

  const options: google.maps.MapOptions = {
    center: center,
    disableDefaultUI: true,
    gestureHandling: 'greedy',
    minZoom: 13,
    zoom: 13,
    mapId: 'a3c55da7dbc95496',
  };

  if (ref.current && !ctx.state?.map) {
    const map = new window.google.maps.Map(ref.current, options);
    ctx.dispatch({
      type: 'SET_MAP',
      payload: map,
    });
  }
};
